export default __webpack_public_path__ + "static/media/bkg--agent.0bba9706.jpg";